const TEST_MODE = false; // switch between Testing and Production

export const environment = {
  production: true,
  VERSION: require('../../package.json').version,
  packageDate: '20261014',
  testMode: TEST_MODE, // toggle this true for local machine dev
  PROD_API_SERVER_ADDRESS: 'https://sws-api.azurewebsites.net',
  TESTING_API_SERVER_ADDRESS: 'https://sws-api-testing.azurewebsites.net',
  appInsights: {
    instrumentationKey: '4eaa45f2-2058-418e-904d-1ef21b95e028'
  },
  FORTE_SCRIPT_URL: "https://sandbox.forte.net/checkout/v2/js",
  MANIFEST_LENGTH_OVERRIDE: 90,
  useDebugSerialConnection: false,
  CLOVER_APP_MARKET_LINK: TEST_MODE ? 'https://sandbox.dev.clover.com/appmarket/apps/E9SK3MHQ0XMPP' : 'https://www.clover.com/appmarket/apps/HD9639SRBJJGY'
};
